export class Deferred {
    promise;
    _isResolved = false;
    _resolve;
    _reject;
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get isResolved() {
        return this._isResolved;
    }
    reject(reason) {
        if (this._isResolved)
            return;
        this._isResolved = true;
        this._reject(reason);
    }
    resolve(param) {
        if (this._isResolved)
            return;
        this._isResolved = true;
        this._resolve(param);
    }
}
//# sourceMappingURL=Deferred.js.map